var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlookCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_456_379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9998 24.977C45.0022 24.6489 44.8324 24.3429 44.5527 24.1714H44.5478L44.5305 24.1616L29.9766 15.5467C29.9134 15.504 29.8486 15.4655 29.7813 15.4302C29.2194 15.1406 28.5517 15.1406 27.9898 15.4302C27.9225 15.4655 27.8569 15.504 27.7945 15.5467L13.2405 24.1608L13.2233 24.1706C12.7787 24.4471 12.6425 25.0319 12.919 25.4766C13.0002 25.6078 13.1126 25.7169 13.2463 25.7948L27.7994 34.4098C27.8626 34.4516 27.9274 34.491 27.9947 34.5262C28.5566 34.8158 29.2243 34.8158 29.7862 34.5262C29.8535 34.491 29.9183 34.4524 29.9815 34.4098L44.5346 25.7948C44.8258 25.6259 45.003 25.3133 44.9998 24.977Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9381 19.225H24.489V27.9793H14.9381V19.225ZM43.0469 10.3254V6.32063C43.0699 5.31903 42.2775 4.48888 41.2759 4.46509H16.4918C15.4902 4.48888 14.6977 5.31985 14.7207 6.32063V10.3254L29.3715 14.2325L43.0469 10.3254Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7207 10.3254H24.4882V19.1158H14.7207V10.3254Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2557 10.3254H24.4883V19.1158L34.2557 27.9063H43.0462V19.1167L34.2557 10.3254Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4883 19.1167H34.2557V27.9071H24.4883V19.1167Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4883 27.9072H34.2557V36.6976H24.4883V27.9072Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.938 27.9793H24.4889V35.938H14.938V27.9793Z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2554 27.9072H43.0458V36.6976H34.2554V27.9072Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5527 25.7415L44.5338 25.7514L29.9807 33.9364C29.9175 33.9758 29.8527 34.0127 29.7855 34.0455C29.5385 34.1628 29.2695 34.2301 28.9963 34.2408L28.2014 33.7757C28.1342 33.742 28.0694 33.7043 28.0062 33.6633L13.257 25.246H13.2504L12.7681 24.9762V41.5465C12.7754 42.6523 13.6778 43.5423 14.7828 43.5349H43.0163C43.0327 43.5349 43.0474 43.5267 43.0655 43.5267C43.2993 43.5119 43.529 43.4635 43.7488 43.384C43.844 43.3438 43.9358 43.2962 44.0236 43.2412C44.0892 43.2043 44.2016 43.1231 44.2016 43.1231C44.702 42.7532 44.9981 42.1683 45.0006 41.5457V24.977C44.9998 25.2936 44.8283 25.5857 44.5527 25.7415Z",
    fill: "url(#paint0_linear_456_379)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.2183 24.9114V25.9269L29.0007 36.4048L13.2458 25.2534C13.2458 25.2477 13.2417 25.2436 13.2359 25.2436L11.7905 24.3741V23.6415L12.3861 23.6317L13.6461 24.3544L13.6756 24.3642L13.7831 24.4323C13.7831 24.4323 28.5905 32.8815 28.6299 32.9004L29.1967 33.2326C29.246 33.2129 29.2944 33.1932 29.3534 33.1744C29.3829 33.1547 44.0534 24.9015 44.0534 24.9015L44.2183 24.9114Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5527 25.7415L44.5338 25.7522L29.9807 33.9373C29.9175 33.9766 29.8527 34.0136 29.7855 34.0464C29.2203 34.3228 28.5591 34.3228 27.9939 34.0464C27.9266 34.0136 27.8618 33.9766 27.7987 33.9373L13.2455 25.7522L13.2283 25.7415C12.9469 25.5889 12.7713 25.2961 12.7681 24.977V41.5465C12.7754 42.6514 13.677 43.5423 14.7819 43.5349H42.9867C44.0917 43.5423 44.994 42.6514 45.0006 41.5465V24.977C44.9998 25.2936 44.8283 25.5857 44.5527 25.7415Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.1925 33.8167L29.9743 33.9389C29.9111 33.9791 29.8463 34.016 29.779 34.0496C29.5387 34.1678 29.2778 34.2367 29.0112 34.2531L34.5483 40.8008L44.2075 43.128C44.4725 42.9279 44.6825 42.6654 44.8203 42.3635L30.1925 33.8167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M31.1795 33.2613L29.9753 33.9381C29.9121 33.9783 29.8473 34.0152 29.78 34.0488C29.5397 34.1669 29.2788 34.2359 29.0122 34.2523L31.606 41.4046L44.211 43.1248C44.7072 42.7523 45.0001 42.1675 45.0001 41.5465V41.3324L31.1795 33.2613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8093 43.5349H42.9838C43.4177 43.5374 43.8402 43.4004 44.1896 43.1445L28.2001 33.7781C28.1329 33.7445 28.068 33.7068 28.0049 33.6657L13.2557 25.2485H13.2491L12.7676 24.977V41.4899C12.7668 42.6178 13.6806 43.5341 14.8093 43.5349Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M26.4422 14.0693V34.9036C26.4405 35.6337 25.9959 36.2908 25.3192 36.5639C25.1092 36.6542 24.8836 36.7009 24.6547 36.7009H12.7676V13.2564H14.7207V12.2794H24.6539C25.6416 12.2827 26.4397 13.0825 26.4422 14.0693Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.4652 15.0463V35.8806C25.4677 36.1168 25.4176 36.3498 25.3184 36.5639C25.0468 37.2325 24.3988 37.6713 23.6777 37.6746H12.7676V13.2556H23.6777C23.9607 13.2531 24.2405 13.3236 24.4882 13.4606C25.087 13.7625 25.4652 14.3761 25.4652 15.0463Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.4652 15.0463V33.9266C25.4603 34.9126 24.6637 35.7124 23.6777 35.7206H12.7676V13.2556H23.6777C23.9607 13.2531 24.2405 13.3236 24.4882 13.4606C25.087 13.7625 25.4652 14.3761 25.4652 15.0463Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.4882 15.0463V33.9266C24.4874 34.9143 23.6884 35.7157 22.7007 35.7206H12.7676V13.2556H22.7007C23.6884 13.2564 24.489 14.057 24.4882 15.0447C24.4882 15.0455 24.4882 15.0455 24.4882 15.0463Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.79074 13.2556H22.6982C23.6866 13.2556 24.4889 14.057 24.4889 15.0463V32.9537C24.4889 33.9422 23.6875 34.7445 22.6982 34.7445H4.79074C3.80145 34.7445 3 33.9422 3 32.9537V15.0463C3 14.0578 3.80145 13.2556 4.79074 13.2556Z",
    fill: "url(#paint1_linear_456_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59617 20.7647C9.0375 19.8246 9.74953 19.0379 10.6412 18.5056C11.6289 17.9404 12.7535 17.6582 13.8905 17.691C14.9446 17.668 15.9847 17.9354 16.8977 18.4637C17.7558 18.9756 18.4473 19.7254 18.887 20.622C19.3669 21.6104 19.6056 22.6982 19.5843 23.7966C19.6072 24.9442 19.3619 26.082 18.8665 27.1172C18.4161 28.0466 17.7025 28.8226 16.8157 29.3509C15.8674 29.8956 14.7887 30.1696 13.6961 30.1441C12.619 30.1704 11.5559 29.8997 10.6223 29.3624C9.75691 28.8497 9.05718 28.0991 8.60601 27.2C8.12367 26.2263 7.88168 25.1501 7.90054 24.064C7.88086 22.9262 8.11875 21.7983 8.59617 20.7647ZM10.7757 26.0688C11.0112 26.6636 11.4098 27.1787 11.9266 27.5552C12.4525 27.9227 13.0825 28.1122 13.7239 28.0966C14.4073 28.1237 15.0807 27.9277 15.6427 27.538C16.1529 27.1623 16.5409 26.6455 16.7599 26.0516C17.0052 25.388 17.1258 24.685 17.1168 23.9779C17.1241 23.2642 17.0109 22.5538 16.7804 21.8779C16.577 21.2675 16.2013 20.7294 15.6984 20.3291C15.1505 19.9214 14.4794 19.7139 13.7969 19.7434C13.1415 19.7262 12.4976 19.9173 11.9578 20.2897C11.4328 20.6679 11.0259 21.188 10.7856 21.7893C10.2524 23.1666 10.2491 24.6932 10.7774 26.0721L10.7757 26.0688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2554 10.3254H43.0458V19.1158H34.2554V10.3254Z",
    fill: "#50D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_456_379",
    x1: 28.8835,
    y1: 24.9767,
    x2: 28.8835,
    y2: 43.5349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_456_379",
    x1: 6.73296,
    y1: 11.8569,
    x2: 20.7554,
    y2: 36.1432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_456_379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookCalendar);
export default __webpack_public_path__ + "static/media/outlook-calendar.8b1faf274f73a9c8410133bb35e786ef.svg";
export { ForwardRef as ReactComponent };